import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { PageWrapper, Title } from '../elements';
import { state } from 'app/pwa/app.cerebral';

import PageContainer from '../common/PageContainer';
import { Text, Button } from './elements';
import { useText } from 'common/hooks';

const deps = {
  locale: state.appContainer.language.locale,
};

export function Support({
  locale,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  const documentationLink = {
    en: 'https://www.ducky.eco/en/support/ducky-challenge',
    es: 'https://www.ducky.eco/es/support/ducky-challenge',
    no: 'https://www.ducky.eco/no-no/support/ducky-challenge',
    ja: 'https://support.ducky.eco/ja/ducky-challenge',
  };

  const ticketLink = {
    en: 'https://www.ducky.eco/en/support/kb-tickets/new',
    es: 'https://www.ducky.eco/es/support/kb-tickets/new',
    no: 'https://www.ducky.eco/no-no/support/kb-tickets/new',
    ja: 'https://support.ducky.eco/ja/kb-tickets/new',
  };

  return (
    <PageContainer tab={'support'}>
      <PageWrapper>
        <Title as={'h2'}>{t('account.settings.support.ducky_support')}</Title>
        <Text>{t('account.settings.support.visit_help_desk')}</Text>
        <Button
          target={'_blank'}
          rel={'noopener noreferrer'}
          href={documentationLink[locale]}
        >
          {t('account.settings.support.browse_articles')}
        </Button>
        <Text>{t('account.settings.support.submit_support_ticket')}</Text>
        <Button
          target={'_blank'}
          rel={'noopener noreferrer'}
          href={ticketLink[locale]}
        >
          {t('account.settings.support.create_ticket')}
        </Button>
      </PageWrapper>
    </PageContainer>
  );
}

export default connect(deps, Support);
